export class QualitySamplePlan {
    constructor({
          id= null, 
          planCode= ``,
          itemId='', 
          itemName=``, 
          sampleName=``,
          sampleCode= ``, 
          samplePerson= ``,
          sampleLeader= ``,
          sampleTime= ``,
          planStatus='',
          planId='',
          furnaceName='',
          furnaceBatch='',
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.itemId=itemId;
      this.itemName =itemName;
      this.sampleName = sampleName;
      this.sampleCode = sampleCode;
      this.samplePerson = samplePerson;
      this.sampleLeader = sampleLeader;
      this.sampleTime = sampleTime;
      this.planStatus=planStatus;
      this.planId=planId;
      this.furnaceName=furnaceName;
      this.furnaceBatch=furnaceBatch;
    }
  }
  export function gridFields() {
    return Object.freeze(
        [
        
      
        {
          key: 'planCode',
          label: 'lbl.qualitySamplePlan.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        },  
        {
          key: 'itemName',
          label: 'lbl.qualitySamplePlan.itemName',
          sortable: true,
          form: {
            type: 'input'
          }
        },           
        {
          key: 'sampleName',
          label: 'lbl.qualitySamplePlan.sampleName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'sampleCode',
          label: 'lbl.qualitySamplePlan.sampleCode',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'samplePerson',
          label: 'lbl.qualitySamplePlan.sampleUser',
          sortable:true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'sampleLeader',
          label: 'lbl.qualitySamplePlan.sampleLeader',
          sortable: true,
          notInTable:true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'furnaceName',
          label: 'lbl.qualitySamplePlan.furnaceName',
          sortable: true,
          form: {
            type: 'select',
            options: [
              { value: '1', text: 'opt.furnaceNumber1' },
              { value: '2', text: 'opt.furnaceNumber2' },
              { value: '3', text: 'opt.furnaceNumber3' },
              { value: '4', text: 'opt.furnaceNumber4' },
              { value: '5', text: 'opt.furnaceNumber5' },
              { value: '6', text: 'opt.furnaceNumber6' },
              { value: 'NO', text: '无' },
            ]
          }
        },
        {
          key: 'furnaceBatch',
          label: 'lbl.qualitySamplePlan.furnaceBatch',
          sortable: true,
          default:"-",
          form: {
            type: 'input'
          }
        },
        {
          key: 'sampleTime',
          label: 'lbl.qualitySamplePlan.sampleTime',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'planStatus',
          label: 'lbl.qualitySamplePlan.sampleStatus',
          sortable: true,
          form: {
          type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'N', text:  'lbl.qualitySamplePlan.sampleStatus.N' },  
                { value: 'S', text:  'lbl.qualitySamplePlan.sampleStatus.S' }, 
                { value: 'R', text:  'lbl.qualitySamplePlan.sampleStatus.R' }, 
                { value: 'C', text:  'lbl.qualitySamplePlan.sampleStatus.C' }, 
                                 
              ]     
        }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new QualitySamplePlan()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.shiftPlanNumFilter',
    'filter.productionDateFilter',
    'filter.plantFilter',
    'filter.shiftTeamFilter',
    'filter.qualityItemFilter'
  ];
  export const filter = {
    'shiftPlanNumFilter': "",
    'productionDateFilter': "",
    'plantFilter': "",
    'shiftTeamFilter': "",
    'qualityItemFilter': ""
  };